module.exports = __webpack_public_path__ + "img/unsetColor.085a98.svg";